(function(){
  if(window.__bmpPriceCtaLayout)return;window.__bmpPriceCtaLayout=true;
  function run(){
    var priceRow=document.querySelector('.bmp-price-row');
    var form=document.querySelector('.bmp-form');
    if(!priceRow||!form)return;
    /* 24/09/2026 : si les sélecteurs sont dans la colonne d'achat, le bouton reste après eux (ordre prix, options, bouton). */
    if(document.querySelector('.bmp-sel-col .bmp-info .bmp-selectors'))return;
    if(priceRow.parentElement&&priceRow.parentElement.classList.contains('bmp-buy-grid'))return;
    var formId=form.getAttribute('id');
    if(!formId){formId='bmp-form-main';form.setAttribute('id',formId);}
    var wrapper=document.createElement('div');
    wrapper.className='bmp-buy-grid';
    priceRow.parentNode.insertBefore(wrapper,priceRow);
    wrapper.appendChild(priceRow);
    var buyCol=document.createElement('div');
    buyCol.className='bmp-buy-col';
    wrapper.appendChild(buyCol);
    var ctaRow=form.querySelector('.bmp-cta-row');
    var dyn=form.querySelector('.bmp-dyn');
    if(ctaRow){
      buyCol.appendChild(ctaRow);
      var submitBtn=ctaRow.querySelector('button[type="submit"], button[name="add"]');
      if(submitBtn)submitBtn.setAttribute('form',formId);
    }
    if(dyn)buyCol.appendChild(dyn);
    /* Texte de l'infobulle prix neuf : défini dans sections/beemac-main-product.liquid selon la source du prix (référence ou sortie). */
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();